/**
 * Parses a concatenated address string to extract just the street address part
 * @param address - The full concatenated address (e.g., "123 Main St, City, State, 12345")
 * @returns The street address part only (e.g., "123 Main St")
 */
export const parseStreetAddress = (address: string): string => {
  if (!address) return "";

  // Split by comma and take the first part (street address)
  const parts = address.split(",");
  return parts[0]?.trim() || "";
};
